export { AudioPlayer } from './component';
